import React, { useState, useRef, useEffect } from 'react';
import { FaPen } from 'react-icons/fa'; // Import pen icon

const ChatTitle = ({ title, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState(title);
  const inputRef = useRef(null);

  useEffect(() => {
    setEditedTitle(title);
  }, [title]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleSubmit = () => {
    if (editedTitle.trim() && editedTitle.trim() !== title) {
      onUpdate(editedTitle.trim());
    }
    setIsEditing(false);
  };

  return (
    <div className="chat-title">
      {isEditing ? (
        <input
          ref={inputRef}
          value={editedTitle}
          onChange={(e) => setEditedTitle(e.target.value)}
          onBlur={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit();
            if (e.key === 'Escape') {
              setEditedTitle(title);
              setIsEditing(false);
            }
          }}
          className="title-input"
          placeholder="Enter chat title"
        />
      ) : (
        <div className="title-container">
          <span className="title-text">{title}</span>
          <button
            className="edit-title-btn"
            onClick={() => setIsEditing(true)}
            title="Edit title"
          >
            <FaPen />
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatTitle;